import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';

// index.html loads the bootstrap script `async`, so it is regularly still missing when a widget
// first asks to render. 100 attempts at 100ms gives it 10s before giving up.
const POLL_INTERVAL_MS = 100;
const MAX_ATTEMPTS = 100;

@Injectable({ providedIn: 'root' })
export class TrustpilotService {
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private zone: NgZone,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  /** Renders a single widget element, waiting for the bootstrap script if it hasn't arrived yet. */
  public render(element: HTMLElement): void {
    if (!this.isBrowser || !element) return;

    // Outside the zone, so retries don't each trigger a change detection run.
    this.zone.runOutsideAngular(() => this.load(element, MAX_ATTEMPTS));
  }

  private load(element: HTMLElement, attemptsLeft: number): void {
    if (window.Trustpilot?.loadFromElement) {
      // Second argument forces a re-render, so the widget still appears if Trustpilot's own
      // scan of the page already processed this element.
      window.Trustpilot.loadFromElement(element, true);
    } else if (attemptsLeft > 0) {
      setTimeout(() => this.load(element, attemptsLeft - 1), POLL_INTERVAL_MS);
    }
  }
}
